import { styled } from '@automata/mui-theme';
import { forwardRef } from 'react';
import {
  Handle as ReactFlowHandle,
  HandleProps as ReactFlowHandleProps,
} from 'reactflow';

import { zIndexValues } from '../styles';

export type Props = ReactFlowHandleProps &
  Omit<React.HTMLAttributes<HTMLDivElement>, 'id'> & {};

const StyledHandle = styled(ReactFlowHandle)`
  background: white;
  border: 4px solid;
  width: 18px;
  height: 18px;
  z-index: ${zIndexValues.handles};
`;

const Handle = forwardRef<HTMLDivElement, Props>(function Forwarded(
  props: Props,
  ref
): JSX.Element {
  return <StyledHandle {...props} ref={ref} />;
});

export default Handle;
